@if (hasBestAvailable) {
  @if (!isAvailable) {
    <mb-alert type="error">
      <mb-alert-description i18n="@@la_opcion_no_esta_disponible_intente_mas_tarde"
        >La opción no esta disponible, intente mas tarde
      </mb-alert-description>
    </mb-alert>
  }
  @if (bestAvailablePrice && bestAvailablePrice.discount.percentage >= 5) {
    <mb-advice align="left" color="success">
      {{ bestAvailable.price.discount.percentage | number: '1.0-0' }}% OFF
    </mb-advice>
  }
  <div
    class="price-description"
    [mb-popover]="popover"
    [mbPopoverDismissible]="true"
    mbPopoverColor="light"
    mbPopoverPosition="above"
  ></div>

  @if (!isAlliance && bestAvailablePrice) {
    <am-price
      [showAmountTotal]="priceByValue === 'TOTAL'"
      [rateSelected]="bestAvailable"
      [fop]="bestAvailable.payment_method.code"
      [quantityNights]="quantityNights"
      [guests]="quantityGuests"
      [quantityRooms]="quantityRooms"
      [isArgentinian]="isArgentinian"
    ></am-price>
  }

  @if (isAlliance) {
    <am-rewards-pricing [price]="superclubPrice"></am-rewards-pricing>
  }
  <button
    id="more-rooms"
    mb-button
    variant="principal"
    color="primary"
    (click)="trackShowRooms()"
    class="button"
  >
    {{ btnLabel }}
  </button>
} @else {
  @if (!isLanding) {
    @if (selectedPaymentMethod === 'all') {
      <mb-alert type="warning" arrow="down">
        <mb-alert-description
          i18n="@@bestroompricebox_uy_no_hay_disponibilidad_podes_probar_otras_fechas"
          >Uy, no hay disponibilidad. Podés probar otras fechas.
        </mb-alert-description>
      </mb-alert>
    } @else {
      <mb-alert type="warning" arrow="down">
        @if (selectedPaymentMethod === 'PREPAID') {
          <mb-alert-description
            i18n="@@uy_no_hay_disponibilidad_podes_pagando_en_cuotas_proba_con_otro_metodo_de_pago_o_en_otra_fecha"
            >Uy, no hay disponibilidad pagando en cuotas. Probá con otro método de pago o en
            otra fecha.
          </mb-alert-description>
        }
        @if (selectedPaymentMethod === 'PAY_AT_DESTINATION') {
          <mb-alert-description
            i18n="@@uy_no_hay_disponibilidad_podes_pagando_en_destino_proba_con_otro_metodo_de_pago_o_en_otra_fecha"
            >Uy, no hay disponibilidad pagando en destino. Probá con otro método de pago o
            en otra fecha.
          </mb-alert-description>
        }
      </mb-alert>
    }
    <modify-search
      id="more-rooms"
      [buttonType]="'button'"
      [modify]="true"
      [hotelStatic]="hotelStaticSearch"
    ></modify-search>
  } @else {
    <div
      class="alert-description"
      i18n="@@bestroompricebox_ingresa_las_fechas_de_tu_estadia_para_ver_los_precios_de_las_habitaciones"
    >
      <strong>Ingresa las fechas</strong> de tu estadía para ver los precios de las
      habitaciones
    </div>
    <modify-search
      [buttonType]="'button'"
      [modify]="false"
      [hotelStatic]="hotelStaticSearch"
    ></modify-search>
  }
}
